<template>
  <v-container fluid fill-height>
    <v-layout align-center justify-center text-center>
      <v-flex xs12 sm8 md4>
        <v-card>
          <v-card-title>
            <h3 style="margin-bottom:10px;">{{$t('views.forgotemail.forgot_email')}}</h3>
          </v-card-title>
          <v-card-text>            
            <v-form :disabled="loading" ref="form" v-model="valid">
              <no-autocomplete-textfield outlined v-model="firstName" 
                :label="$t('globals.firstname')" :rules="[$rules.required]" class="required"></no-autocomplete-textfield>
              <no-autocomplete-textfield outlined v-model="lastName" 
                :label="$t('globals.lastname')" :rules="[$rules.required]" class="required"></no-autocomplete-textfield>
              <vue-recaptcha v-on:expired="recaptchaValid=false" v-on:verify="recaptchaCallback($event)" :sitekey="settings.SiteKey"></vue-recaptcha>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-row>
              <v-col cols="6">
                <v-btn color="primary" text block
                  @click="cancel"
                >{{$t('globals.cancel')}}</v-btn>
              </v-col>
              <v-col cols="6">
                <v-btn block :disabled="!valid || !recaptchaValid || loading" color="primary"
                  @click="handleSubmit"
                >{{$t('components.membersmanagementtable.send_email')}}</v-btn>
              </v-col>
            </v-row>
          </v-card-actions>
          <v-snackbar
            v-model="snackbar"
            :color="color"
            :multi-line="true"
            :timeout="6000"
            :vertical="true"
          >
            {{$t(message)}}
          <v-btn dark text @click="snackbar = false">{{$t('globals.close')}}</v-btn>
        </v-snackbar>
        <error-handler :error="error"></error-handler>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>


<script>
  import VueRecaptcha from 'vue-recaptcha';
  import { mapGetters, mapActions } from "vuex";
  import ErrorHandler from "../components/ErrorHandler";
  import NoAutocompleteTextfield from "../components/NoAutocompleteTextfield";
  export default {
    name: "register",
    data() {
      return {
        error: null,
        recaptchaValid: false,
        valid: false,
        firstName: "",
        lastName: "",
        loading: false,
        //snackbar
        snackbar:false,
        color:null,
        message:""
      };
    },
    watch: {
    },
    computed: {
      ...mapGetters("common", ["messages"]),
      ...mapGetters("auth", ["user"]),
      ...mapGetters("common", { selectedPlan: "plan", settings: "settings" }),
      ...mapGetters("plansMembers", { planParameters: "planOptions" }),
      ...mapGetters("common", ["language"]),
    },
    methods: {
      /*$t(args) {
        console.log(this.messages, args)
        if (Object.keys(this.messages).indexOf(args) < 0) {
            this.messages[args]="TRANSLATION REQUIRED"
        }
        return "TRANSLATION REQUIRED";
    },*/
      ...mapActions("applicationUsers", ["forgotEmail"]),
      recaptchaCallback(event) {
        this.recaptchaValid = true
      },
      async handleSubmit() {
        try {
          this.loading = true;
          await this.forgotEmail( { payload:{ LastName: this.lastName, FirstName: this.firstName, Language: this.language.language } } )
          this.message=this.$t('views.forgotemail.success');
            this.snackbar=true;
            this.loading=false;
            this.color="success"
        }
        catch(error) {
          error.message = this.$t('views.forgotemail.error');
          this.error = error
        }
        this.loading=false;
      },
      cancel(){
        window.location=window.location.origin+"/";
      }
    },
    components: { VueRecaptcha, ErrorHandler, NoAutocompleteTextfield }
  };
</script>